export default "__VITE_ASSET__8b9f605f__"